import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Icon from '../../../components/Icon';
import AppModal from '../../../components/Modal';
import { getLoggedUser, removeOrganizationMember } from '../../../actions/api';
import * as types from '../../../constants/ActionTypes';
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withRemoveOrganizationMemberConfirmModal = (WrappedComponent) => connect(void 0, mapDispatchToProps)(withTranslation()(class RemoveOrganizationMemberConfirmModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            processing: false,
            user: {},
            organization: {},
            callback: () => void 0,
        };
        this.handleCloseModal = () => {
            this.setState({ open: false });
        };
        this.handleClick = (user, organization, callback) => {
            this.setState({
                open: true,
                processing: false,
                user: user,
                organization: organization,
                callback: callback || (() => void 0),
            });
        };
        this.handleSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState({
                processing: true,
            });
            this.props
                // @ts-expect-error TS2339: Property name does not exist on type {}
                .dispatch(removeOrganizationMember(this.state.organization.name, this.state.user.id))
                .then((action) => {
                if (action.type === types.REMOVE_ORGANIZATION_MEMBER_SUCCESS) {
                    this.setState({ open: false, processing: false });
                    this.props.dispatch(getLoggedUser()).then((action) => {
                        if (action.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                            // @todo: dirty
                            this.props.dispatch({
                                type: types.LOGGED_USER,
                                payload: action.response.data,
                            });
                        }
                    });
                    this.state.callback();
                }
            });
        };
    }
    renderModal() {
        const { t } = this.props;
        const { user, organization } = this.state;
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('organizations.removeOrganizationMember') }), _jsx(ModalBody, { children: _jsx("p", { children: t('organizations.removeMemberDescription', {
                            user: user
                                // @ts-expect-error TS2339: Property displayName does not exist on type {}
                                ? (user.displayName || user.username) +
                                    // @ts-expect-error TS2339: Property emails does not exist on type {}
                                    (user.emails && user.emails.length > 0 ? ` (${user.emails[0]})` : '')
                                : '',
                            // @ts-expect-error TS2339: Property name does not exist on type {}
                            organization: organization ? organization.name : '',
                        }) }) }), _jsxs(ModalFooter, { children: [_jsxs(Button, { color: "primary", onClick: this.handleSubmit, disabled: this.state.processing, children: [!this.state.processing ? null : (_jsx(Icon, { name: "spinner", fixedWidth: true, spin: true, className: "mr-2" })), t('organizations.removeMember')] }), _jsx(Button, { color: "light", onClick: this.handleCloseModal, children: t('cancel') })] })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onRemoveOrganizationMemberClick: this.handleClick }), !this.state.open ? null : _jsx(AppModal, { children: this.renderModal() })] }));
    }
}));
